export const authMakeCookieData = async (newAccessToken:string) => {
  const expirationDate = new Date();
  expirationDate.setTime(expirationDate.getTime() + 60 * 60* 1000);
  
  const cookieValue =`Authorization=${newAccessToken}; expires=${expirationDate.toUTCString()}; path=/`

  document.cookie= cookieValue;
}

export const getAccessTokenInCookie = () => {
  const cookies = document.cookie.split(";");

  for (let i=0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith('Authorization=')) {
      return cookie.substring('Authorization='.length, cookie.length);
    }
  };

  return null;
};

export const deleteCookie = async (cookie:string) => {
  document.cookie = `Authorization=; Max-age=0; path=/;`
}